import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";

/**
 * Reusable page-level CTA banner. Buttons default to Request a Quote + phone.
 * Pass `primary` and `secondary` to override.
 */
export default function CTABanner({
  title = "Protect Your Business Today",
  subtitle = "Whether you need a new fire alarm system, annual servicing, emergency lighting maintenance or fire extinguisher inspections, our team is here to help. Contact our team today for a free consultation and quotation.",
  primary = { to: "/contact", label: "Request a Free Quote" },
  secondary = { to: "/contact", label: "Contact Our Team", icon: ArrowRight },
  showPhone = false,
}) {
  return (
    <section className="bg-slate-900 text-white relative overflow-hidden" data-testid="cta-banner">
      <div className="fss-grid-bg absolute inset-0 opacity-[0.06]" aria-hidden />
      <div className="fss-ribbon absolute top-0 inset-x-0" />
      <div className="fss-container py-16 md:py-20 relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-red-500 mb-3">
            Get in touch
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-semibold leading-tight">
            {title}
          </h2>
          <p className="mt-3 text-slate-300 max-w-2xl">{subtitle}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
          <Link to={primary.to} className="fss-btn fss-btn-accent w-full sm:w-auto" data-testid="cta-banner-primary">
            {primary.label}
          </Link>
          {showPhone ? (
            <a
              href="tel:018351454"
              className="fss-btn fss-btn-outline border-slate-700 text-white hover:text-green-500 hover:border-green-500 w-full sm:w-auto"
              data-testid="cta-banner-call"
            >
              <Phone className="w-4 h-4 mr-2" />
              01 835 1454
            </a>
          ) : secondary ? (
            <Link
              to={secondary.to}
              className="fss-btn fss-btn-outline border-slate-700 text-white hover:text-green-500 hover:border-green-500 w-full sm:w-auto"
              data-testid="cta-banner-secondary"
            >
              {secondary.label}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
}
